// @core/api/endpoints/booking/search_available_resources.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SearchAvailableResourcesRequest,
  SearchAvailableResourcesResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Search available resources
 * Searches for bookable resources available in the requested time window. Filters by type, category, location radius, price range, and minimum rating.
 */
export async function SearchAvailableResources(
  data: SearchAvailableResourcesRequest,
  options?: RequestOptions
): Promise<SearchAvailableResourcesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/resources/search`;
  const requestOptions = options;
  return client.post<SearchAvailableResourcesResponse>(requestPath, data, requestOptions);
}
